<script>
    import NumericStepper from "../lib/controls/NumericStepper.svelte";

    export let reservation;
</script>

<div class="row">
    <div class="col-md-3 col-6 mb-3">
        <label>No of adults</label>
        <NumericStepper bind:value={reservation.adults} min="1" max="15"/>
    </div>
    <div class="col-md-3 col-6 mb-3">
        <label>No of children</label>
        <NumericStepper bind:value={reservation.children} min="0" max="15"/>
    </div>
    <div class="col-md-3 col-6 mb-3">
        <label>No of infants</label>
        <NumericStepper bind:value={reservation.infants} min="0" max="15"/>
    </div>
    <div class="col-md-3 col-6 mb-3">
        <label>No of luggage</label>
        <NumericStepper bind:value={reservation.luggage} min="0" max="15"/>
        <div class="control-tip text-center">
            medium or big size
        </div>
    </div>
</div>

{#if reservation.children > 0 || reservation.infants > 0}
    <div class="row">
        {#if reservation.children > 0}
            <div class="col-md-3 col-6 mb-3">
                <label>Baby seats</label>
                <NumericStepper bind:value={reservation.baby_seats} min="0" max={reservation.children}/>
                <div class="control-tip text-center">
                    1 - 4 years old
                </div>
            </div>
            <div class="col-md-3 col-6 mb-3">
                <label>Boosters</label>
                <NumericStepper bind:value={reservation.boosters} min="0" max={reservation.children}/>
                <div class="control-tip text-center">
                    5 - 6 years old
                </div>
            </div>
        {/if}
        {#if reservation.infants > 0}
            <div class="col-md-3 col-6 mb-3">
                <label>Infant seats</label>
                <NumericStepper bind:value={reservation.infant_seats} min="0" max={reservation.infants}/>
                <div class="control-tip text-center">
                    3 - 12 months old
                </div>
            </div>
        {/if}
    </div>
{/if}

<style>
    .control-tip {
        font-size: 13px;
        color: #6d6d6d;
        background: #f7f7f7;
        border-radius: 3px;
        margin-top: 1px;
    }
</style>